<template>
    <div>

        <h6 v-if="(profileId == 0)" class="heading-small text-muted mb-4 text-truncate">Add New Supplier  {{ (inputName) ? (" - " + this.inputName) : "" }}</h6>
        <h6 v-else-if="profileId != 0 && $attrs.viewMode == true" class="heading-small text-muted mb-4 text-truncate">View Supplier - {{this.inputName}}</h6>
        <h6 v-else class="heading-small text-muted mb-4 text-truncate">Edit Supplier - {{this.inputName}}</h6>

        <base-alert v-if="errors.length" type="danger">
            <b>You have the following error(s):</b>
            <li v-for="error in errors" :key="error">{{ error }}</li>
        </base-alert>

        <b-tabs v-show="profileId != 0 && this.$attrs.viewMode == true" content-class="mt-3">
            <b-tab title="Details" active v-on:click="openDetails"></b-tab>
            <b-tab title="History" v-on:click="openHistory">
                <b><label>Created By: </label></b>
                {{ inputCreatedBy || "System"  }} | {{ inputCreatedAt | dateFilter }}
                <br>
                <b><label>Updated By:</label></b>
                {{ inputUpdatedBy || "System"  }} | {{ inputUpdatedAt | dateFilter }}
            </b-tab>
        </b-tabs>

        <form id="form-proper">
            <div v-if="customFormMode == 1" v-show="showDetails">
                <a-tabs defaultActiveKey="1">
                    <a-tab-pane tab="Basic" key="1">
                        <base-input alternative="" label="Code" placeholder="" v-model="inputCode"
                            input-classes="form-control" />
                        <base-input alternative="" label="Name" placeholder="" v-model="inputName"
                            input-classes="form-control" required />
                        <base-input label="Country" style="display:none;">
                            <a-auto-complete
                                style="width: 100%; display:none;"
                                placeholder="Country"
                                :filter-option="filterOption"
                                @select="onChangeCountry"
                                :value="country.label"
                                :allowClear='true'
                            >
                                <template slot="dataSource">
                                    <a-select-option v-for="s in countryOptions" :key="'country'+s.id.toString()" :text="s.name">{{s.name}}</a-select-option>
                                </template>
                            </a-auto-complete>
                        </base-input>
                        <base-input alternative="" label="Country" placeholder="" :value="country.label" input-classes="form-control" required/>
                        <base-input alternative="" label="Zip Code" placeholder="" v-model="inputZipCode" input-classes="form-control" required/>
                        <base-input alternative="" label="Province" placeholder="" v-model="inputProvince" input-classes="form-control" required/>
                        <base-input alternative="" label="City" placeholder="" v-model="inputCity" input-classes="form-control" required/>
                        <base-input alternative="" label="Barangay" placeholder="" v-model="inputBarangay" input-classes="form-control" required/>
                        <base-input alternative="" label="Billing Address" placeholder="" input-classes="form-control"
                            required>
                            <textarea class="form-control" rows="4" v-model="inputBillingAddress" />
                        </base-input>
                        <base-input alternative="" label="Phone" placeholder="" v-model="inputPhone"
                            input-classes="form-control" />
                        <base-input alternative="" label="Mobile No." placeholder="" v-model="inputMobile"
                            input-classes="form-control" />
                        <base-input alternative="" label="Fax" placeholder="" v-model="inputFax"
                            input-classes="form-control" />
                        <base-input alternative="" label="Contact Person" placeholder="" v-model="inputContactPerson"
                            input-classes="form-control" />
                        <base-input alternative="" label="Position Title" placeholder="" v-model="inputPositionTitle"
                            input-classes="form-control" />
                        <base-input alternative="" label="Email" placeholder="" v-model="inputEmail"
                            input-classes="form-control" type="email" />
                        <base-input alternative="" label="Remark">
                            <textarea rows="4" class="form-control" v-model="inputRemark" />
                        </base-input>
                    </a-tab-pane>
                    <a-tab-pane tab="Advanced" key="2" forceRender>

                        <!-- 1935 - Multi Header discount -->
                        <base-input label="Header Discount">
                            <a-select mode="tags" :maxTagCount='10' maxTagPlaceholder='...' v-model='inputDiscount'
                                placeholder='Discount' style="width: 100%;" input-classes="form-control" :disabled="this.$attrs.viewMode"></a-select>
                        </base-input>
                        <base-input label="Supports Discount">
                            <a-select mode="tags" :maxTagCount='10' maxTagPlaceholder='...'
                                v-model='inputSupportDiscount' placeholder='Discount' style="width: 100%;"
                                input-classes="form-control" :disabled="this.$attrs.viewMode"></a-select>
                        </base-input>
                        <!-- 1935 - Multi discount -->

                        <base-input alternative="" label="Commission" placeholder="" v-model="inputCommission"
                            input-classes="form-control" />
                        <base-input label="Payment Terms">
                            <div class="form-group row">
                                <div class="col-sm-6">
                                    <input type="text" class="form-control" v-model="paymentTermName" disabled>
                                </div>
                                <div class="col-sm-6">
                                    <autocomplete ref="autocomplete" placeholder="Search Payment Term"
                                        :source="paymentTermEndpoint" input-class="form-control" results-property="data"
                                        :results-display="formattedDisplay" :request-headers="authHeaders"
                                        @selected="getPaymentTerm">
                                    </autocomplete>
                                </div>
                            </div>
                        </base-input>
                        <base-input label="Currency">
                            <div class="form-group row">
                                <div class="col-sm-6">
                                    <div class="input-group mb-3">
                                        <input type="text" class="form-control" v-model="currencyName" disabled>
                                        <div class="input-group-append">
                                            <button class="ant-btn ant-input-search-button" style="height:35px"
                                                @click.prevent="removeCurrency">
                                                <a-icon type="close" />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <autocomplete ref="autocomplete" placeholder="Search Currencies"
                                        :source="currencyEndpoint" input-class="form-control" results-property="data"
                                        :results-display="formattedDisplay" :request-headers="authHeaders"
                                        @selected="getCurrency">
                                    </autocomplete>
                                </div>
                            </div>
                        </base-input>
                        <base-input alternative=""
                            v-if="inputCurrency > 0 && inputCurrency != this.defaultCurrencyDetails.id"
                            label="Currency Rate" placeholder="" v-model="currencyRate" input-classes="form-control"
                            disabled />
                        <base-input label="Vat Type">
                            <select class="form-control form-control-sm" v-model="inputVatType">
                                <option v-for="option in vatTypeOptions" v-bind:value="option.key" :key="option.key">
                                    {{ option.value }}
                                </option>
                            </select>
                        </base-input>
                        <base-input label="WTax Code">
                                    <a-select   showSearch
                                        v-model="wtax_code"
                                        style="width: 100%" placeholder="Please select"
                                        :filterOption="false"
                                        :notFoundContent="fetching ? undefined : null"
                                        :disabled="viewMode"
                                        @search="handleWtaxesSearch"
                                        @focus="handleWtaxesSearch"
                                    >
                                <a-spin v-if="fetching" slot="notFoundContent" size="small" />
                                <a-select-option v-for="option in wtaxCodes" :key="option.id" :value="option.w_tax_code">{{option.w_tax_code}} - {{parseFloat(option.percentage * 100).toFixed(2)}}%</a-select-option>
                            </a-select>
                        </base-input>
                        <base-input label="Add On Charge" >
                            <base-checkbox :disabled="viewMode" class="col-md-12"  v-model="is_with_add_on_charge">
                                        With Add On Charge
                            </base-checkbox>
                        </base-input>
                        <base-input alternative="" label="Supplier TIN No." placeholder="" v-model="inputTinNo"
                            input-classes="form-control" required />
                        <base-input label="Supplier Type">
                            <div class="form-group row">
                                <div class="col-sm-6">
                                    <input type="text" class="form-control" v-model="supplierTypeName" disabled>
                                </div>
                                <div class="col-sm-6">
                                    <autocomplete ref="autocomplete" placeholder="Search Supplier Types"
                                        :source="supplierTypeEndpoint" input-class="form-control"
                                        results-property="data" :results-display="formattedDisplay"
                                        :request-headers="authHeaders" @selected="getSupplierType">
                                    </autocomplete>
                                </div>
                            </div>
                        </base-input>
                        <base-input label="Cutoff">
                            <select class="form-control form-control-sm" v-model="inputCutoff">
                                <option v-for="option in cutOffOptions" v-bind:value="option.key" :key="option.key">
                                    {{ option.value }}
                                </option>
                            </select>
                        </base-input>
                        <base-input alternative="" label="Stock Buffer (days)" placeholder="" v-model="inputStockBuffer"
                            input-classes="form-control" type="number" required />
                        <base-input alternative="" label="Delivery Lead Time (days)" placeholder=""
                            v-model="inputDeliveryLeadTime" input-classes="form-control" type="number" required />
                        <base-input alternative="" label="Average Daily Sale of (days)" placeholder=""
                            v-model="inputAverageDailySalesOf" input-classes="form-control" type="number" required />
                        <base-input alternative="" label="No. of days before Cancellation Date" placeholder=""
                            v-model="inputDaysToCancel" input-classes="form-control" type="number" required />
                    </a-tab-pane>
                </a-tabs>
            </div>
            <div v-if="customFormMode == 2">
                <!-- Override -->
                <dynamic-form :convertedJson="{ mode: customForm.mode, groups: customForm.groups }"
                    :formSettings="supplier" @valueUpdated="updateSettings" :key="dynamicFormKey" />
            </div>
            <div v-if="customFormMode == 3">
                <!-- Append -->
                <a-tabs defaultActiveKey="1">
                    <a-tab-pane tab="Basic" key="1">
                        <base-input alternative="" label="Code" placeholder="" v-model="inputCode"
                            input-classes="form-control" />
                        <base-input alternative="" label="Name" placeholder="" v-model="inputName"
                            input-classes="form-control" required />
                        <base-input label="Country" style="display:none;">
                            <a-auto-complete
                                style="width: 100%; display:none;"
                                placeholder="Country"
                                :filter-option="filterOption"
                                @select="onChangeCountry"
                                :value="country.label"
                                :allowClear='true'
                            >
                                <template slot="dataSource">
                                    <a-select-option v-for="s in countryOptions" :key="'country'+s.id.toString()" :text="s.name">{{s.name}}</a-select-option>
                                </template>
                            </a-auto-complete>
                        </base-input>
                        <base-input alternative="" label="Country" placeholder="" :value="country.label" input-classes="form-control" required disabled/>
                        <base-input alternative="" label="Zip Code" placeholder="" v-model="inputZipCode" input-classes="form-control" required/>
                        <base-input alternative="" label="Province" placeholder="" v-model="inputProvince" input-classes="form-control" required/>
                        <base-input alternative="" label="City" placeholder="" v-model="inputCity" input-classes="form-control" required/>
                        <base-input alternative="" label="Barangay" placeholder="" v-model="inputBarangay" input-classes="form-control" required/>
                        <base-input alternative="" label="Billing Address" placeholder="" input-classes="form-control"
                            required>
                            <textarea class="form-control" rows="4" v-model="inputBillingAddress" />
                        </base-input>
                        <base-input alternative="" label="Phone" placeholder="" v-model="inputPhone"
                            input-classes="form-control" />
                        <base-input alternative="" label="Mobile No." placeholder="" v-model="inputMobile"
                            input-classes="form-control" />
                        <base-input alternative="" label="Fax" placeholder="" v-model="inputFax"
                            input-classes="form-control" />
                        <base-input alternative="" label="Contact Person" placeholder="" v-model="inputContactPerson"
                            input-classes="form-control" />
                        <base-input alternative="" label="Position Title" placeholder="" v-model="inputPositionTitle"
                            input-classes="form-control" />
                        <base-input alternative="" label="Email" placeholder="" v-model="inputEmail"
                            input-classes="form-control" type="email" />
                        <base-input alternative="" label="Remark">
                            <textarea rows="4" class="form-control" v-model="inputRemark" />
                        </base-input>
                    </a-tab-pane>
                    <a-tab-pane tab="Advanced" key="2" forceRender>
                        <base-input alternative="" label="Discount" placeholder="" v-model="inputDiscount"
                            input-classes="form-control" />
                        <base-input alternative="" label="Commission" placeholder="" v-model="inputCommission"
                            input-classes="form-control" />
                        <base-input alternative="" label="Support Discount" placeholder=""
                            v-model="inputSupportDiscount" input-classes="form-control" />
                        <base-input label="Payment Terms">
                            <div class="form-group row">
                                <div class="col-sm-6">
                                    <input type="text" class="form-control" v-model="paymentTermName" disabled>
                                </div>
                                <div class="col-sm-6">
                                    <autocomplete ref="autocomplete" placeholder="Search Payment Term"
                                        :source="paymentTermEndpoint" input-class="form-control" results-property="data"
                                        :results-display="formattedDisplay" :request-headers="authHeaders"
                                        @selected="getPaymentTerm">
                                    </autocomplete>
                                </div>
                            </div>
                        </base-input>
                        <base-input label="Currency">
                            <div class="form-group row">
                                <div class="col-sm-6">
                                    <div class="input-group mb-3">
                                        <input type="text" class="form-control" v-model="currencyName" disabled>
                                        <div class="input-group-append">
                                            <button class="ant-btn ant-input-search-button" style="height:35px"
                                                @click.prevent="removeCurrency">
                                                <a-icon type="close" />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <autocomplete ref="autocomplete" placeholder="Search Currencies"
                                        :source="currencyEndpoint" input-class="form-control" results-property="data"
                                        :results-display="formattedDisplay" :request-headers="authHeaders"
                                        @selected="getCurrency">
                                    </autocomplete>
                                </div>
                            </div>
                        </base-input>
                        <base-input alternative="" v-if="inputCurrency > 0" label="Currency Rate" placeholder=""
                            v-model="currencyRate" input-classes="form-control" disabled />
                        <base-input label="Vat Type">
                            <select class="form-control form-control-sm" v-model="inputVatType">
                                <option v-for="option in vatTypeOptions" v-bind:value="option.key" :key="option.key">
                                    {{ option.value }}
                                </option>
                            </select>
                        </base-input>
                        <base-input label="WTax Code">
                                    <a-select   showSearch
                                        v-model="wtax_code"
                                        style="width: 100%" placeholder="Please select"
                                        :filterOption="false"
                                        :notFoundContent="fetching ? undefined : null"
                                        :disabled="viewMode"
                                        @search="handleWtaxesSearch"
                                        @focus="handleWtaxesSearch"
                                    >
                                <a-spin v-if="fetching" slot="notFoundContent" size="small" />
                                <a-select-option v-for="option in wtaxCodes" :key="option.id" :value="option.w_tax_code">{{option.w_tax_code}} - {{parseFloat(option.percentage * 100).toFixed(2)}}%</a-select-option>
                            </a-select>
                        </base-input>
                        <base-input label="Add On Charge" >
                            <base-checkbox :disabled="viewMode" class="col-md-12"  v-model="is_with_add_on_charge">
                                        With Add On Charge
                            </base-checkbox>
                        </base-input>
                        <base-input alternative="" label="Supplier TIN No." placeholder="" v-model="inputTinNo"
                            input-classes="form-control" required />
                        <base-input label="Supplier Type">
                            <div class="form-group row">
                                <div class="col-sm-6">
                                    <input type="text" class="form-control" v-model="supplierTypeName" disabled>
                                </div>
                                <div class="col-sm-6">
                                    <autocomplete ref="autocomplete" placeholder="Search Supplier Types"
                                        :source="supplierTypeEndpoint" input-class="form-control"
                                        results-property="data" :results-display="formattedDisplay"
                                        :request-headers="authHeaders" @selected="getSupplierType">
                                    </autocomplete>
                                </div>
                            </div>
                        </base-input>
                        <base-input label="Cutoff">
                            <select class="form-control form-control-sm" v-model="inputCutoff">
                                <option v-for="option in cutOffOptions" v-bind:value="option.key" :key="option.key">
                                    {{ option.value }}
                                </option>
                            </select>
                        </base-input>
                        <base-input alternative="" label="Stock Buffer (days)" placeholder="" v-model="inputStockBuffer"
                            input-classes="form-control" type="number" required />
                        <base-input alternative="" label="Delivery Lead Time (days)" placeholder=""
                            v-model="inputDeliveryLeadTime" input-classes="form-control" type="number" required />
                        <base-input alternative="" label="Average Daily Sale of (days)" placeholder=""
                            v-model="inputAverageDailySalesOf" input-classes="form-control" type="number" required />
                        <base-input alternative="" label="No. of days before Cancellation Date" placeholder=""
                            v-model="inputDaysToCancel" input-classes="form-control" type="number" required />
                    </a-tab-pane>
                    <a-tab-pane tab="Custom Fields" key="3">
                        <dynamic-form 
                        :convertedJson="{
                            mode: customForm.mode,
                            groups: customForm.groups_append,
                        }"
                        :formSettings="supplier"
                        @valueUpdated="updateSettings"
                        :key="dynamicFormKey"
                        :showErrors="false"
                        />
                    </a-tab-pane>
                </a-tabs>
            </div>

            <div class='mt-5' v-if="this.$attrs.viewMode != true">
                <div v-if="serverType == 'ho'"
                    style="position: absolute; bottom: 0px;right: 0px; width: -webkit-fill-available; background-color: #f2f2f2 ;padding: 10px;">
                    <button v-if="(profileId == 0)" type="button" class="btn btn-primary float-right"
                        @click.prevent="create">Add</button>
                    <button v-else type="button" class="btn btn-primary float-right"
                        @click.prevent="update">Update</button>
                </div>
                <div v-else
                    style="position: absolute; bottom: 0px;right: 0px; width: -webkit-fill-available; background-color: #f2f2f2 ;padding: 10px;">
                    <button type="button" class="btn btn-primary float-right"
                        @click.prevent="$emit('closeDrawer', null)">Close</button>
                </div>
            </div>

        </form>
    </div>
</template>

<script>
import HTTPRequest from '../../controllers/httpRequest.js'
import secureStorage from '../../controllers/secureStorage.js'
import DynamicForm from '../DynamicForm.vue'
import ValidateField from '../../components/validateFormUtils.js'
import { mapState } from 'vuex'
import Autocomplete from 'vuejs-auto-complete'
import moment from 'moment'

var component_x;
export default {
    components: {
        Autocomplete, DynamicForm
    },
    computed: {
        ...mapState(['endPoint', 'profileId', 'serverType']),
    },
    mounted: async function () {
        await this.getCountryOptions()
        // Meta-data Call
        const sytemModule = await HTTPRequest.getRequest(this.endPoint + 'system_modules/Supplier?field_name=name', null)
        const sytemModuleId = sytemModule.id
        const accSystemModuleRequest = await HTTPRequest.getRequest(this.endPoint + 'account_system_modules/' + sytemModuleId + '?field_name=system_module_id', null)
        if (this.isJsonString(accSystemModuleRequest.meta) == true) {
            const accSystemModule = JSON.parse(accSystemModuleRequest.meta)
            if (accSystemModule != null) {
                if (accSystemModule.form_mode != undefined) {
                    this.customFormMode = accSystemModule.form_mode
                }
                if (accSystemModule.customized_forms != undefined) {
                    this.customForm = accSystemModule.customized_forms
                }
            }
        }
        if (this.serverType == 'branch') {
            var form = document.getElementById("form-proper")
            var elements = form.elements;
            for (var i = 0, len = elements.length; i < len; ++i) {
                elements[i].disabled = true;
            }
        } else {
            if (this.$attrs.viewMode == true) {
                var form = document.getElementById("form-proper")
                var elements = form.elements;
                for (var i = 0, len = elements.length; i < len; ++i) {
                    elements[i].disabled = true;
                }
            }
        }
        component_x = this
        if (component_x.profileId > 0) {
            var data = await HTTPRequest.getRequest(component_x.endPoint + 'suppliers/' + component_x.profileId, null)
            if (data == undefined) {
                component_x.$router.go()
            } else {
                if (data["error"] == undefined) {
                    component_x.inputCode = data["code"]
                    component_x.inputName = data["name"]
                    component_x.inputZipCode = data["zip_code"]
                    component_x.inputProvince = data["province_name"]
                    component_x.inputCity = data["city_name"]
                    component_x.inputBarangay = data["barangay_name"]
                    component_x.inputBillingAddress = data["billing_address"]
                    component_x.inputPhone = data["telephone"]
                    component_x.inputMobile = data["mobile"]
                    component_x.inputFax = data["fax"]
                    component_x.inputContactPerson = data["contact_person"]
                    component_x.inputPositionTitle = data["contact_position"]
                    component_x.inputEmail = data["email"]
                    component_x.inputRemark = data["remark"]
                    component_x.inputDiscount = (data["discount_text"]) ? data["discount_text"].toString().split(",") : []
                    component_x.inputSupportDiscount = (data["support_discount_text"]) ? data["support_discount_text"].toString().split(",") : []
                    component_x.inputCommission = data["commission_rate"]
                    component_x.inputPaymentTerm = data["payment_term_id"]
                    component_x.paymentTermName = data["payment_term_name"]
                    component_x.inputCurrency = data["currency_id"]
                    component_x.currencyName = data["currency_name"]
                    component_x.currencyRate = data["currency_rate"]
                    component_x.inputVatType = data["vat_type"]
                    component_x.inputTinNo = data["tin"]
                    component_x.inputSupplierType = data["supplier_type_id"]
                    component_x.supplierTypeName = data["supplier_type_name"]
                    component_x.inputCutoff = data["cutoff_type"]
                    component_x.inputStockBuffer = data["stock_buffer"]
                    component_x.inputDeliveryLeadTime = data["delivery_lead_time"]
                    component_x.inputAverageDailySalesOf = data["average_daily_sale"]
                    component_x.inputDaysToCancel = data["days_to_cancel"]
                    component_x.supplier = data
                    component_x.inputCreatedBy = data["created_by"]
                    component_x.inputCreatedAt = data["created_at"]
                    component_x.inputUpdatedBy = data["updated_by"]
                    component_x.inputUpdatedAt = data["updated_at"]
                    component_x.is_with_add_on_charge = data["is_with_add_on_charge"]
                    component_x.country_id = data["country_id"]
                    component_x.country.key = data["country_id"]
                    component_x.country.label = data["country_name"]
                    var wtaxCodes = await HTTPRequest.getRequest(this.endPoint + "accounts/wtax_codes?wtax_code="+data["wtax_code"] , null, null)
                    this.wtaxCodes = wtaxCodes
                    if(wtaxCodes.length > 0)
                        this.wtax_code = wtaxCodes[0]['w_tax_code']
                } else {
                    this.errors = data["error"].split(",");
                }
            }
        }
        this.dynamicFormKey++;
        this.getDefaultCurrency()
        
    },
    data: function () {
        return {
            viewMode: false,
            countryOptions: [],
            country: {},
            wtaxCodes: [],
            wtax_code: '',
            is_with_add_on_charge: false,
            inputCode: '',
            inputName: '',
            inputZipCode: '',
            inputProvince: '',
            inputCity: '',
            inputBarangay: '',
            inputBillingAddress: '',
            inputPhone: '',
            inputMobile: '',
            inputFax: '',
            inputContactPerson: '',
            inputPositionTitle: '',
            inputEmail: null,
            inputRemark: '',
            inputDiscount: [],
            inputCommission: '',
            inputSupportDiscount: [],
            inputPaymentTerm: '',
            paymentTermName: "",
            inputCurrency: '',
            currencyName: "",
            currencyRate: "",
            inputVatType: 'V',
            inputTinNo: '',
            inputCutoff: '',
            inputStockBuffer: '',
            inputDeliveryLeadTime: '',
            inputAverageDailySalesOf: '',
            inputDaysToCancel: '',
            inputCreatedBy: '',
            inputCreatedAt: '',
            inputUpdatedBy: '',
            inputUpdatedAt: '',
            errors: [],
            // FOR META-DATA
            customFormMode: 1,
            customForm: {},
            profileData: {},
            dynamicFormKey: 0,
            supplier: {},
            formErrors: [],

            options: '',
            inputSupplierType: '',
            supplierTypeName: "",
            authHeaders: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress") },
            vatTypeOptions: [
                { key: null, value: null },
                { key: "V", value: "VATable" },
                { key: "X", value: "VAT-exempt" },
                { key: "Z", value: "Zero-rated" }
            ], cutOffOptions: [
                { key: null, value: null },
                { key: "W", value: "Weekly" },
                { key: "S", value: "Semi-monthly" },
                { key: "M", value: "Monthly" }
            ],
            defaultCurrencyDetails: {},
            showDetails: true
        }
    },
    filters: {
        dateFilter: function (timestamp) {
            return moment(timestamp).format('L LTS')
        }
    },
    methods: {
        filterOption(input, option) {
            return (
                option.componentOptions.children[0].text
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
            );
        },
        async getCountryOptions() {
            var countries = await HTTPRequest.getRequest(this.endPoint + '/countries/get_valid_countries', null, null);
            this.countryOptions = countries.map(country => ({ id: country.id, name: country.name }));
        },
        async onChangeCountry(country, option){
            country = country.replace('country','')
            this.country = {key: country, label: option.data.attrs.text}
        },
        async handleWtaxesSearch(value){
            this.fetching = true;
            if(value == undefined)
                this.wtaxCodes = await HTTPRequest.getRequest(this.endPoint + "accounts/wtax_codes" , null, null)
            else
                this.wtaxCodes = await HTTPRequest.getRequest(this.endPoint + "accounts/wtax_codes?wtax_code=" + value , null, null)

            //this.wtaxCodes = this.paymentTerms.data
            this.fetching = false;
        },
        updateSupplierParams(){
            if (this.supplier.b2b_customer_code == undefined){
                this.supplier.b2b_customer_code = "";
            }
        },
        updateSettings(newFormSettings, settingsGrouping, errors) {
            // console.log("---------*****----------")
            var formSettingsCopy = this.supplier
            var mergedHash = Object.assign({}, formSettingsCopy, newFormSettings);
            this.formErrors = errors
            this.supplier = mergedHash
        },
        isJsonString(str) {
            try {
                var json = JSON.parse(str);
                return (typeof json === 'object');
            } catch (e) {
                return false;
            }
        },
        supplierTypeEndpoint(input) {
            return this.endPoint + '/supplier_types?name=' + input;
        },
        getSupplierType(group) {
            this.supplierTypeName = group.display;
            this.inputSupplierType = group.value;
        },
        getCurrency(group) {
            this.currencyName = group.display;
            this.inputCurrency = group.value;
            this.currencyRate = group.selectedObject.conversion;
        },
        async getDefaultCurrency() {
            this.defaultCurrencyDetails = await HTTPRequest.getRequest(this.endPoint + 'currencies/get_default_currency', null)
        },
        currencyEndpoint(input) {
            var params = this.defaultCurrencyDetails.id > 0 ? '&default_currency_id=' + this.defaultCurrencyDetails.id : ""
            return this.endPoint + '/currencies?code=' + input + params;
        },
        getPaymentTerm(group) {
            this.paymentTermName = group.display;
            this.inputPaymentTerm = group.value;
        },
        paymentTermEndpoint(input) {
            return this.endPoint + '/payment_terms?name=' + input;
        },
        formattedDisplay(result) {
            return result.name + ' [' + result.code + ']';
        },
        get_supplier_types: async function () {
            var supplier_types = await HTTPRequest.getRequest(this.endPoint + 'supplier_types/', null);
            this.options = supplier_types['data'];
        },
        validateDiscount(value) {
            var isValid = true
            var discountRegex = /(^L[0-9]+(\.[0-9][0-9]?)?$|^[0-9]+(\.[0-9][0-9]?)?$|^[0-9]+(\.[0-9][0-9]?)?\%$)/;
            if (value != '') {
                value.forEach(function (row) {
                    if (!discountRegex.test(row)) isValid = false;
                });
            }
            return isValid;
        },
        validateForm() {
            this.errors = [];

            // 1935 - Must be amount or percentage
            if (!this.validateDiscount(this.inputDiscount.toString().split(',')))
                this.errors.push('Header Discount is not valid, it must be amount or percentage');

            if (!this.validateDiscount(this.inputSupportDiscount.toString().split(',')))
                this.errors.push('Supports Discount is not valid, it must be amount or percentage');
            // 1935 - Must be amount or percentage

            // this.errors.push(ValidateField.required('Code', this.inputCode));
            // this.errors.push(ValidateField.alphanumericWithSpecialChars('Code', this.inputCode));
            this.errors.push(ValidateField.charMinAndMax('Code', this.inputCode, 3, 15));
            this.errors.push(ValidateField.required('Name', this.inputName));
            // this.errors.push(ValidateField.alphanumericWithSpecialChars('Name', this.inputName));
            this.errors.push(ValidateField.charMinAndMax('Name', this.inputName, 0, 200));
            this.errors.push(ValidateField.required('Billing Address', this.inputBillingAddress));
            this.errors.push(ValidateField.required('Zip Code', this.inputZipCode));
            this.errors.push(ValidateField.required('Province', this.inputProvince));
            this.errors.push(ValidateField.required('City', this.inputCity));
            this.errors.push(ValidateField.required('Barangay', this.inputBarangay));
            this.errors.push(ValidateField.alphanumericWithNewline('Billing Address', this.inputBillingAddress));
            this.errors.push(ValidateField.charMinAndMax('Billing Address', this.inputBillingAddress, 0, 200));
            // this.errors.push(ValidateField.phoneNumberFormat('Phone No.', this.inputPhone));
            this.errors.push(ValidateField.phoneNumberFormat('Mobile No.', this.inputMobile));
            this.errors.push(ValidateField.phoneNumberFormat('Fax', this.inputFax));
            this.errors.push(ValidateField.alphabetWithSpace('Contact Person', this.inputContactPerson));
            this.errors.push(ValidateField.charMinAndMax('Contact Person', this.inputContactPerson, 0, 200));
            this.errors.push(ValidateField.alphanumericWithSpecialChars('Position Title', this.inputPositionTitle));
            this.errors.push(ValidateField.charMinAndMax('Position Title', this.inputPositionTitle, 0, 200));
            if (this.inputEmail != null && this.inputEmail != "") {
                this.errors.push(ValidateField.emailFormat('Email', this.inputEmail));
            }
            // this.errors.push(ValidateField.emailFormat('Email', this.inputEmail));
            this.errors.push(ValidateField.charMinAndMax('Email', this.inputEmail, 0, 200));
            this.errors.push(ValidateField.alphanumericWithSpecialChars('Remark', this.inputRemark));
            this.errors.push(ValidateField.charMinAndMax('Remark', this.inputRemark, 0, 200));
            this.errors.push(ValidateField.decimalFormat('Commission', this.inputCommission));
            this.errors.push(ValidateField.required('Supplier Tin No.', this.inputTinNo));
            this.errors.push(ValidateField.alphanumericWithSpecialChars('Supplier Tin No.', this.inputTinNo));
            this.errors.push(ValidateField.charMinAndMax('Supplier Tin No.', this.inputTinNo, 0, 50));
            this.errors.push(ValidateField.required('Stock Buffer (days)', this.inputStockBuffer));
            this.errors.push(ValidateField.wholeNumberFormat('Stock Buffer (days)', this.inputStockBuffer));
            this.errors.push(ValidateField.required('Delivery Lead Time (days)', this.inputDeliveryLeadTime));
            this.errors.push(ValidateField.wholeNumberFormat('Delivery Lead Time (days)', this.inputDeliveryLeadTime));
            this.errors.push(ValidateField.required('Average Daily Sale of (days)', this.inputAverageDailySalesOf));
            this.errors.push(ValidateField.decimalFormat('Average Daily Sale of (days)', this.inputAverageDailySalesOf));
            this.errors.push(ValidateField.required('No. of days before Cancellation Date', this.inputDaysToCancel));
            this.errors.push(ValidateField.wholeNumberFormat('No. of days before Cancellation Date', this.inputDaysToCancel));
            if (this.customFormMode == 3 && this.formErrors.length > 0) {
                this.errors = [...this.errors, ...this.formErrors]
            }
            this.errors = this._.compact(this.errors);
            document.getElementsByClassName('ant-drawer-wrapper-body')[0].scrollTop = 0;
            return this.errors.length;
        },
        create: async function () {
            if (!this.validateForm()) {
                var supplierPayload = {
                    supplier: {
                        code: this.inputCode.trim(),
                        name: this.inputName.trim(),
                        zip_code: this.inputZipCode,
                        wtax_code: this.wtax_code,
                        is_with_add_on_charge: this.is_with_add_on_charge,
                        province_name: this.inputProvince,
                        city_name: this.inputCity,
                        barangay_name: this.inputBarangay,
                        billing_address: this.inputBillingAddress,
                        telephone: this.inputPhone,
                        mobile: this.inputMobile,
                        fax: this.inputFax,
                        contact_person: this.inputContactPerson,
                        contact_position: this.inputPositionTitle,
                        email: this.inputEmail,
                        remark: this.inputRemark,
                        discount_text: this.inputDiscount.toString(),
                        commission_rate: this.inputCommission,
                        support_discount_text: this.inputSupportDiscount.toString(),
                        payment_term_id: this.inputPaymentTerm,
                        currency_id: this.inputCurrency,
                        vat_type: this.inputVatType,
                        tin: this.inputTinNo,
                        supplier_type_id: this.inputSupplierType,
                        cutoff_type: this.inputCutoff,
                        stock_buffer: this.inputStockBuffer,
                        delivery_lead_time: this.inputDeliveryLeadTime,
                        average_daily_sale: this.inputAverageDailySalesOf,
                        days_to_cancel: this.inputDaysToCancel,
                        country_id: this.country.key,
                        country_name: this.country.label
                    }
                }
                var supplierPayloadMerged = Object.assign({}, this.supplier, supplierPayload.supplier);
                // console.log(supplierPayloadMerged)
                // var put_request = await HTTPRequest.putRequest(this.endPoint + 'suppliers/' + this.profileId, null, supplierPayloadMerged)
                var post_request = await HTTPRequest.postRequest(this.endPoint + 'suppliers', null, supplierPayloadMerged)
                if (post_request == undefined) {
                    this.$emit('refreshPage', event)
                    this.$notification['success']({
                        message: 'Success',
                        description: "Supplier successfully Created."
                    });
                } else {
                    if (post_request["error"] == undefined) {
                        this.$emit('refreshPage', event)
                        this.$notification['success']({
                            message: 'Success',
                            description: "Supplier successfully Created."
                        });
                    } else {
                        this.errors = post_request["error"].split(","); //format will change when error message from rails has comma
                        //this.$router.push("/")
                    }
                }
            }
        },
        update: async function () {
            if (!this.validateForm()) {
                var supplierPayload = {
                    supplier: {
                        code: this.inputCode.trim(),
                        name: this.inputName.trim(),
                        zip_code: this.inputZipCode,
                        wtax_code: this.wtax_code,
                        is_with_add_on_charge: this.is_with_add_on_charge,
                        province_name: this.inputProvince,
                        city_name: this.inputCity,
                        barangay_name: this.inputBarangay,
                        billing_address: this.inputBillingAddress,
                        telephone: this.inputPhone,
                        mobile: this.inputMobile,
                        fax: this.inputFax,
                        contact_person: this.inputContactPerson,
                        contact_position: this.inputPositionTitle,
                        email: this.inputEmail,
                        remark: this.inputRemark,
                        discount_text: this.inputDiscount.toString(),
                        commission_rate: this.inputCommission,
                        support_discount_text: this.inputSupportDiscount.toString(),
                        payment_term_id: this.inputPaymentTerm,
                        currency_id: this.inputCurrency,
                        vat_type: this.inputVatType,
                        tin: this.inputTinNo,
                        supplier_type_id: this.inputSupplierType,
                        cutoff_type: this.inputCutoff,
                        stock_buffer: this.inputStockBuffer,
                        delivery_lead_time: this.inputDeliveryLeadTime,
                        average_daily_sale: this.inputAverageDailySalesOf,
                        days_to_cancel: this.inputDaysToCancel,
                        country_id: this.country.key,
                        country_name: this.country.label
                    }
                }

                // supplierPayload = supplierPayload.merge(this.supplier)
                var supplierPayloadMerged = Object.assign({}, this.supplier, supplierPayload.supplier);
                // console.log("*************************")
                // console.log(supplierPayloadMerged)
                var put_request = await HTTPRequest.putRequest(this.endPoint + 'suppliers/' + this.profileId, null, supplierPayloadMerged)
                if (put_request == undefined) {
                    this.$emit('refreshPage', event)
                    this.$notification['success']({
                        message: 'Success',
                        description: "Supplier successfully updated."
                    });
                } else {
                    if (put_request["error"] == undefined) {
                        this.$emit('refreshPage', event)
                        this.$notification['success']({
                            message: 'Success',
                            description: "Supplier successfully updated."
                        });
                    } else {
                        this.errors = put_request["error"].split(","); //format will change when error message from rails has comma                        //this.$router.push("/")
                    }
                }
            }
        },
        async removeCurrency() {
            if (this.defaultCurrencyDetails.currency == undefined) {
                this.defaultCurrencyDetails = await HTTPRequest.getRequest(this.endPoint + 'currencies/get_default_currency', null)
            }
            this.inputCurrency = null
            this.currencyName = this.defaultCurrencyDetails.currency
        },
        openDetails() {
            this.showDetails = true
        },
        openHistory() {
            this.showDetails = false
        },
    }
}
</script>

<style>
</style>
